
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms'
import { RouterModule } from "@angular/router";
import { MatIconModule } from "@angular/material/icon";
import { FlexLayoutModule } from "@angular/flex-layout";
import {FuseSidebarModule} from "../../../../@fuse/components";
import {TranslateModule} from "@ngx-translate/core";
import {FuseDirectivesModule} from "../../../../@fuse/directives/directives";
import {MatRippleModule} from "@angular/material/core";
import {MatButtonModule} from "@angular/material/button";
import {MatMenuModule} from "@angular/material/menu";
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {MatTabsModule} from "@angular/material/tabs";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {ChartsModule} from "ng2-charts";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {DeleteMenuDialogComponent} from "./dialog/deleteMenuDialog.component";
import {MenuResolve} from "./resolvers/menu.resolve";
import {MenuMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatDialogModule} from "@angular/material/dialog";
import {MenuComponent} from "./menu.component";
import {MenuFormComponent} from "./menuForm.component";
import {MatTreeModule} from "@angular/material/tree";
import {CreateMenuItemDialogComponent} from "./dialog/createMenuItemDialog.component";
import {MatAutocompleteModule} from "@angular/material/autocomplete";

@NgModule({
    declarations: [
        DeleteMenuDialogComponent,
        CreateMenuItemDialogComponent,
        MenuMainSidebarComponent,
        MenuComponent,
        MenuFormComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        FlexLayoutModule,
        FuseSidebarModule,
        TranslateModule,
        FuseDirectivesModule,
        MatRippleModule,
        MatButtonModule,
        MatMenuModule,
        NgxChartsModule,
        MatTabsModule,
        MatFormFieldModule,
        MatSelectModule,
        ChartsModule,
        NgxDatatableModule,
        MatDatepickerModule,
        MatInputModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatDialogModule,
        MatTreeModule,
        MatAutocompleteModule,

    ],
    providers: [
        MenuResolve,
    ],
    bootstrap: [
        DeleteMenuDialogComponent,
        MenuComponent,
        MenuFormComponent,
    ]
})
export class MenuModule { }
